import { formatDecimalPlaces } from "../../../../../helpers/format-decimal-places";
import { useGetMyProfile } from "../../../../../hooks/profile/use-get-my-profile";

export const InfoCoins = () => {
  const { user } = useGetMyProfile();

  return (
    <div
      style={{
        background: "linear-gradient(135deg, #9B30E6 0%, #C77DFF 100%)",
        borderRadius: "16px",
        padding: "20px",
        textAlign: "center",
        color: "#fff",
        marginBottom: "20px",
        justifyContent: "center",
        boxShadow: "0 10px 24px rgba(155, 48, 230, 0.25)",
      }}
    >
      <div
        style={{
          fontSize: "13px",
          fontWeight: 600,
          color: "rgba(255, 255, 255, 0.85)",
          marginBottom: "10px",
        }}
      >
        Coins Trading
      </div>

      <div
        style={{
          display: "inline-flex",
          alignItems: "center",
          justifyContent: "center",
          gap: "8px",
          padding: "8px 20px",
          borderRadius: "999px",
          background: "rgba(255, 255, 255, 0.18)",
          border: "1px solid rgba(255, 255, 255, 0.35)",
        }}
      >
        <img src={"/coin.png"} style={{ width: "22px" }} />
        <span style={{ fontSize: "24px", fontWeight: 800 }}>
          {formatDecimalPlaces(user?.agency?.coinsForSale ?? 0)}
        </span>
      </div>
    </div>
  );
};
